import { Check } from '@phosphor-icons/react';
import telegramService from '../../services/telegram';

/**
 * Выбор мест из избранного — шаг «Места» в мастере и «Добавить места»
 * в редакторе.
 *
 * Номер справа — порядок выбора, он же порядок в маршруте; поменять его
 * можно на следующем шаге перетаскиванием. Раньше номер стоял слева
 * в синем квадрате, а справа ещё и галочка — одно и то же дважды.
 *
 * - `favorites` — записи избранного `{ id, place }`;
 * - `selectedIds` — выбранные id мест по порядку;
 * - `lockedIds` — уже в маршруте (в редакторе): отмечены и не снимаются.
 */
const PlacePicker = ({ favorites, selectedIds, onToggle, lockedIds = [] }) => {
  const places = favorites.map((f) => f.place).filter(Boolean);

  if (places.length === 0) {
    return (
      <p className="m-0 py-6 text-center text-body text-theme-text-secondary">
        В избранном пока нет мест. Сохраните места сердечком — из них
        и собирается маршрут.
      </p>
    );
  }

  return (
    <ul className="m-0 flex list-none flex-col p-0">
      {places.map((place) => {
        const locked = lockedIds.includes(place.id);
        const order = selectedIds.indexOf(place.id);
        const checked = locked || order !== -1;
        const thumb = place.images?.[0]?.url || null;
        return (
          <li key={place.id} className="border-b border-theme-border last:border-b-0">
            <button
              onClick={() => { if (locked) return; telegramService.hapticFeedback('light'); onToggle(place); }}
              disabled={locked}
              aria-pressed={checked}
              className="flex min-h-[64px] w-full items-center gap-3 border-0 bg-transparent px-0 py-2 text-left disabled:opacity-60"
              style={{ WebkitTapHighlightColor: 'transparent' }}
            >
              <div
                className="w-10 shrink-0 overflow-hidden rounded-md bg-theme-card-secondary"
                style={{ aspectRatio: '3 / 4' }}
              >
                {thumb && <img src={thumb} alt="" loading="lazy" className="h-full w-full object-cover" />}
              </div>
              <div className="min-w-0 flex-1">
                <div className="truncate text-body text-theme-text-primary">{place.title}</div>
                {(place.metro || place.address) && (
                  <div className="truncate text-caption text-theme-text-secondary">
                    {place.metro ? `м. ${place.metro}` : place.address}
                  </div>
                )}
              </div>
              {/* Отметка: пустой круг — не выбрано, синий с номером — выбрано,
                  серый с галочкой — уже в маршруте */}
              <span
                className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-kicker tabular"
                style={locked
                  ? { background: 'var(--color-text-hint)', color: 'var(--color-card)' }
                  : checked
                    ? { background: 'var(--color-action)', color: 'var(--color-on-action)' }
                    : { border: '1.5px solid var(--color-border-strong)' }}
              >
                {locked ? <Check size={14} weight="bold" /> : checked ? order + 1 : null}
              </span>
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default PlacePicker;
